module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-Trafo2.3ae392f3.png";